if (!customElements.get('marquee-component')) {
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();

      this.marquee = this.querySelector('[data-marquee]');
      this.marqueeItems = this.querySelector('[data-marquee-items]');
      this.marqueeItemsDuplicated = null;

      this.toggleMarquee();

      ['shopify:section:load', 'resize', 'load'].forEach((eventName) => {
        window.addEventListener(eventName, () => {
          this.toggleMarquee();
        });
      });
    }

    toggleMarquee() {
      const enableMarquee =
        this.marqueeItems.clientWidth > this.marquee.clientWidth;

      this.marquee.classList.toggle('is-enabled', enableMarquee);

      if (enableMarquee) {
        if (!this.marqueeItemsDuplicated) {
          this.marqueeItemsDuplicated = this.marqueeItems.cloneNode(true);
          this.marqueeItemsDuplicated.setAttribute('aria-hidden', true);
          this.marquee.appendChild(this.marqueeItemsDuplicated);
        }

        return;
      }

      this.marqueeItemsDuplicated?.remove();
      this.marqueeItemsDuplicated = null;
    }
  }

  customElements.define('marquee-component', MarqueeComponent);
}
